export const navBarRouterPathURl = '/frontend';

export const partnerNameFromUrl = '/frontend';

export const defaultAppVersion = "1.0.0";